import React, { useState } from "react";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import PlusButton from "../../../components/PlusButton";
import MinusButton from "../../../components/MinusButton";
import { useGetMGA } from "./hooks/useGetMGA";
import { useCarrierProgram } from "../../Utilities/ProducerConfiguration/CarrierProgram/hooks/useCarrierProgram";
import MaterialSubTable from "../../../components/tables/MaterialSubTable";
import ProdCodeFormLOBSection from "./ProdCodeFormLOBSection";
import { useCodeLevel } from "./hooks/useCodeLevel";

const ProdCodeFormProducerCodeSection = ({
  tableName,
  masterCarrierId,
  state,
  handleProducerCodeInputs,
  handleRemoveProducerCodeRow,
  handleAddProducerCodeRow,
  carrierProducerCodeData,
  loboptions,
  prodtypeoptions,
  distChannelOpts,
  addMainForm,
  employeeOpts,
  employeeFranchiseOpts,
  isChannelFranchise,
  handleIsFranchise,
  handleMACheckBox,
  rowIsFranchise,
  clearDropdowns,
  setClearDropdowns,
  rowIsClearDropdowns,
  isResetCarrierDependency,
  agencies,
  rowId,
  empFranchisesOpts,
}) => {
  const { data: mgaOpt } = useGetMGA();
  const cProgramOpt = useCarrierProgram();
  const { data: codeLevels } = useCodeLevel();
  const codeLevelOptions = codeLevels
    ?.filter((cLevels) => cLevels.isActive === true)
    .map((x) => {
      return { label: x.codeLevelName, value: x.codeLevelId };
    });
  const data = carrierProducerCodeData?.ProducerCodes
    ? carrierProducerCodeData?.ProducerCodes
    : carrierProducerCodeData;
  // const { data: allProducerCodeListByCarrier } =
  //   useGetProducerCodeListByCarrierId(carrierProducerCodeData?.MasterCarrierId);
  const columns = [
    {
      name: (
        <div>
          Producer Code: <span className="text-red-500 text-xs3">*</span>
        </div>
      ),
      cellStyle: {
        width: 250,
        maxWidth: 300,
      },
      render: (row) => (
        <div
          className={"pb-2 w-full block text-gray-700 expandedLabel fontExpand"}
        >
          <div className="">
            {<span className="text-red-500 text-xs3">*</span>} Producer Code:
          </div>

          <TextInput
            value={row.producerCode}
            inputTextHeight={"h-7"}
            onChange={(e) => {
              handleProducerCodeInputs(
                tableName,
                "producerCode",
                e.target.value,
                masterCarrierId,
                state,
                row.RowId,
                row.producerCodeRowId === null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
            onKeyPress={(event) => {
              if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </div>
      ),
    },
    {
      name: (
        <div>
          Code Level: <span className="text-red-500 text-xs3">*</span>
        </div>
      ),
      cellStyle: {
        width: 250,
        maxWidth: 300,
      },
      render: (row) => (
        <div className={"pb-2 text-quinary text-xs"}>
          <div className="w-full block text-gray-700 expandedLabel fontExpand">
            {<span className="text-red-500 text-xs3">*</span>} Code Level:
          </div>

          <SelectInput
            value={row.codeLevel}
            options={codeLevelOptions}
            onChange={(selectedOptions) => {
              handleProducerCodeInputs(
                tableName,
                "CodeLevel",
                selectedOptions ? selectedOptions.label : null,
                masterCarrierId,
                state,
                row.RowId,
                row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
          />
        </div>
      ),
    },
    {
      name: <div>Sub Code:</div>,
      cellStyle: {
        width: 250,
        maxWidth: 300,
      },
      render: (row) => (
        <div
          className={"pb-2 w-full block text-gray-700 expandedLabel fontExpand"}
        >
          <div className="">Sub Code:</div>
          <TextInput
            value={data.map((x) => x.ProducerSubCode)[rowId - 1]}
            inputTextHeight={"h-7"}
            onChange={(selectedOptions) => {
              handleProducerCodeInputs(
                tableName,
                "producerSubCode",
                selectedOptions ? selectedOptions.target.value : null,
                masterCarrierId,
                state,
                row.RowId,
                row.producerCodeRowId == null ? 1 : row.producerCodeRowId,
                addMainForm
              );
            }}
            onKeyPress={(event) => {
              if (!/^[a-zA-Z0-9-]*$/.test(event.key)) {
                event.preventDefault();
              }
            }}
          />
        </div>
      ),
    },
    // {
    //   name: "Action",
    //   render: (row) => (
    //     <div className={"pb-2 w-full text-quinary text-xs "}>
    //       <div className="w-full text-center  block font-medium text-gray-700 ">
    //         Action
    //       </div>

    //       {row.producerCodeRowId > 1 ? (
    //         <div className="mt-2 flex justify-center">
    //           <MinusButton
    //             buttonText="Remove"
    //             className="ml-3 px-3 py-px gap-2"
    //             onClick={() => {
    //               handleRemoveProducerCodeRow(row, tableName);
    //             }}
    //           />
    //         </div>
    //       ) : (
    //         <div className="mt-2 flex justify-center">
    //           <PlusButton
    //             buttonText="Add Producer Code"
    //             className="ml-3 px-3 py-px gap-2"
    //             onClick={() => handleAddProducerCodeRow(row, tableName)}
    //           />
    //         </div>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  return (
    <MaterialSubTable
      columns={columns}
      data={
        carrierProducerCodeData && carrierProducerCodeData.ProducerCodes
          ? carrierProducerCodeData.ProducerCodes.map((d, i) => ({
              ...d,
              tableData: {
                showDetailPanel: (row) => (
                  <ProdCodeFormLOBSection
                    tableName={tableName}
                    masterCarrierId={masterCarrierId}
                    state={state}
                    row={row}
                    employeeOpts={employeeOpts}
                    employeeFranchiseOpts={employeeFranchiseOpts}
                    isChannelFranchise={isChannelFranchise}
                    rowId={row.producerCodeRowId}
                    handleProducerCodeInputs={handleProducerCodeInputs}
                    handleRemoveProducerCodeRow={handleRemoveProducerCodeRow}
                    handleAddProducerCodeRow={handleAddProducerCodeRow}
                    carrierProducerCodeData={carrierProducerCodeData}
                    loboptions={loboptions}
                    isResetCarrierDependency={isResetCarrierDependency}
                    rowIsClearDropdowns={rowIsClearDropdowns}
                    distChannelOpts={distChannelOpts}
                    addMainForm={addMainForm}
                    handleMACheckBox={handleMACheckBox}
                    mgaOpt={mgaOpt}
                    cProgramOpt={cProgramOpt}
                    prodtypeoptions={prodtypeoptions}
                    handleIsFranchise={handleIsFranchise}
                    rowIsFranchise={rowIsFranchise}
                    clearDropDowns={clearDropdowns}
                    setClearDropdowns={setClearDropdowns}
                    agencies={agencies}
                    empFranchisesOpts={empFranchisesOpts}
                  />
                ),
              },
            })) || []
          : carrierProducerCodeData
      }
      loading={false}
    />
  );
};

export default ProdCodeFormProducerCodeSection;
